import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
    selector: 'modal-detalhe-grafico',
    templateUrl: 'modal-detalhe-grafico-component.html',
    styleUrls: ['modal-detalhe-grafico-component.scss']
})

export class ModalDetalheGraficoComponent implements OnInit {
    @ViewChild('lineChart', {static: false}) lineChart;

    chart: any;
    titulo: any;
    isFilter: any;
    isLegend: any;
    legRotate: any;
    stepSize: any;
    legBottom: any;
    legends: any;
    infoData: any;

    constructor(private modalCtrl: ModalController,
                private navParams: NavParams) {

        this.chart = this.navParams.get('chart');
        this.titulo = this.navParams.get('titulo');
        this.isFilter = this.navParams.get('isFilter');
        this.isLegend = this.navParams.get('isLegend');
        this.legRotate = this.navParams.get('legRotate');
        this.stepSize = this.navParams.get('stepSize');
        this.legBottom = this.navParams.get('legBottom');
        this.legends = this.navParams.get('legends');
        this.infoData = this.navParams.get('infoData');
    }

    async ngOnInit() {
        console.log('ngOnInit - > ModalDetalheGraficoComponent');
    }

    ionViewDidEnter() {
    }

    onClose() {
        this.modalCtrl.dismiss();
    }
}
